export default __webpack_public_path__ + "static/media/ic-dl-lecture-videos.5e76cd55.svg";